import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCounterReceipt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.6 5.00039H8.2M4.6 10.2004H8.2M4.6 7.60039H8.2M11 6.20039V2.80039C11 2.02719 11.6268 1.40039 12.4 1.40039C13.1732 1.40039 13.8 2.02719 13.8 2.80039V5.88039C13.8 5.9924 13.8 6.04841 13.7782 6.09119C13.759 6.12882 13.7284 6.15942 13.6908 6.17859C13.648 6.20039 13.592 6.20039 13.48 6.20039H11ZM11 6.20039V14.6004L8.8 13.4004L6.4 14.6004L4 13.4004L2 14.6004L2 2.80039C2 2.02719 2.62681 1.40039 3.4 1.40039H12.2",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCounterReceipt);
export { ForwardRef as ReactComponent };
